import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { listarLicitaciones } from "../api";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { HiX, HiOutlineDownload, HiOutlineCalendar } from "react-icons/hi";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "../styles.css";
import logo from "../assets/logo.png";

moment.locale("es");
moment.updateLocale("es", { week: { dow: 1 } });
const localizer = momentLocalizer(moment);

const EventoModal = ({ evento, onClose, getColor }) => {
    if (!evento) return null;
    return createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal animate-fadeIn" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0 }}>Expediente: <span style={{ color: 'var(--accent-primary)' }}>{evento.resource.numero_expediente}</span></h3>
                    <button className="btn-icon" onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}>
                        <HiX size={20} />
                    </button>
                </div>

                <div className="detalle-info" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div>
                        <label style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>Título</label>
                        <p style={{ margin: '4px 0 0', fontWeight: 500 }}>{evento.resource.titulo || "Sin título"}</p>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <div>
                            <label style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>País</label>
                            <p style={{ margin: '4px 0 0' }}>{evento.resource.pais || "—"}</p>
                        </div>
                        <div>
                            <label style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>Estado</label>
                            <div style={{ marginTop: '4px' }}>
                                <span className={`estado-badge estado-${evento.estado.replace(" ", "-")}`} style={{ fontSize: '0.7rem' }}>
                                    {evento.estado}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <label style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>Organismo</label>
                        <p style={{ margin: '4px 0 0' }}>{evento.resource.organismo || "—"}</p>
                    </div>
                    <div>
                        <label style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', fontWeight: 600, textTransform: 'uppercase' }}>Fecha Presentación</label>
                        <p style={{ margin: '4px 0 0' }}>{moment(evento.resource.fecha_presentacion).format("DD/MM/YYYY")}</p>
                    </div>
                </div>

                <div className="modal-footer" style={{ marginTop: '24px', textAlign: 'right' }}>
                    <button className="btn-gestion" onClick={onClose}>Cerrar</button>
                </div>
            </div>
        </div>,
        document.body
    );
};

const ShowMoreModal = ({ state, onClose, onSelect, getColor }) => {
    if (!state) return null;
    return createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal animate-fadeIn" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0 }}>Eventos para el {moment(state.date).format("DD/MM/YYYY")}</h3>
                    <button className="btn-icon" onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}>
                        <HiX size={20} />
                    </button>
                </div>

                <div className="events-list" style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '60vh', overflowY: 'auto' }}>
                    {state.events.map((evt) => (
                        <div
                            key={`${evt.id}-${evt.title}`}
                            onClick={() => onSelect(evt)}
                            style={{
                                background: 'rgba(255,255,255,0.03)',
                                border: '1px solid var(--glass-border)',
                                borderLeft: `4px solid ${getColor(evt.estado)}`,
                                padding: '12px',
                                borderRadius: 'var(--radius-md)',
                                cursor: 'pointer',
                                transition: 'var(--transition-fast)'
                            }}
                            className="event-item-hover"
                        >
                            <div style={{ fontWeight: 600, fontSize: '0.9rem', marginBottom: '4px' }}>{evt.title}</div>
                            <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>{evt.resource.organismo}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>,
        document.body
    );
};

const Calendario = ({ onCerrar }) => {
    const [eventos, setEventos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
    const [showMoreState, setShowMoreState] = useState(null);
    const [fechaVisible, setFechaVisible] = useState(new Date());
    const calendarioRef = useRef();

    const getColorByEstado = (estado) => {
        const s = (estado || "").toLowerCase();
        if (s === "presentada") return "#2563eb";   /* azul */
        if (s === "adjudicada") return "#059669";   /* verde */
        if (s === "cerrada") return "#64748b";      /* slate gris */
        if (s === "no adjudicada") return "#dc2626"; /* rojo */
        if (s === "proxima") return "#d97706";      /* ámbar */
        return "#0891b2";                           /* cyan (pendiente/otro) */
    };

    useEffect(() => {
        const cargarEventos = async () => {
            try {
                const licitaciones = await listarLicitaciones();
                const hoy = new Date();
                const eventosFormateados = licitaciones
                    .filter((l) => {
                        if (!l.fecha_presentacion) return false;
                        const est = (l.estado || "").toLowerCase();
                        return est !== "pendiente de aceptar" && est !== "rechazada";
                    })
                    .map((l) => {
                        const fecha = new Date(l.fecha_presentacion);
                        const diasRestantes = Math.ceil((fecha - hoy) / (1000 * 60 * 60 * 24));
                        let estado = (l.estado || "pendiente").toLowerCase();
                        if (estado === "pendiente") {
                            const hoyNormalizado = new Date();
                            hoyNormalizado.setHours(0, 0, 0, 0);
                            const fechaNormalizada = new Date(fecha);
                            fechaNormalizada.setHours(0, 0, 0, 0);

                            if (fechaNormalizada < hoyNormalizado) estado = "cerrada";
                            else if (diasRestantes <= 7) estado = "proxima";
                        }
                        return {
                            id: l.numero_expediente,
                            title: l.titulo || "Sin título",
                            start: fecha,
                            end: fecha,
                            allDay: true,
                            resource: l,
                            estado,
                        };
                    });
                setEventos(eventosFormateados);
            } catch (err) {
                console.error("Error cargando calendario:", err);
            } finally {
                setLoading(false);
            }
        };
        cargarEventos();
    }, []);

    const eventStyleGetter = (event) => ({
        style: {
            backgroundColor: getColorByEstado(event.estado),
            borderRadius: '5px',
            border: 'none',
            color: '#ffffff',
            fontSize: '0.74rem',
            fontWeight: '600',
            padding: '2px 7px',
            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
        }
    });

    const exportarPDF = async () => {
        if (!calendarioRef.current) return;
        const canvas = await html2canvas(calendarioRef.current, {
            scale: 2,
            useCORS: true,
            backgroundColor: '#0f172a'
        });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("landscape", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = pageWidth - 20;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.setFontSize(16);
        pdf.setTextColor(15, 23, 42);
        pdf.text(`Calendario de Licitaciones - ${moment(fechaVisible).format("MMMM YYYY")}`, 10, 15);
        pdf.addImage(imgData, "PNG", 10, 20, imgWidth, imgHeight);
        pdf.save(`Calendario_Licitaciones_${moment().format("YYYYMMDD")}.pdf`);
    };

    if (loading) return (
        <div className="loading-container animate-fadeIn" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'var(--text-secondary)' }}>
            <div className="loader"></div>
            <p style={{ marginLeft: '12px' }}>Cargando calendario...</p>
        </div>
    );

    return (
        <div className="calendario-view animate-fadeIn" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className="dashboard-header" style={{ marginBottom: '24px' }}>
                <div className="header-info">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div className="brand-logo" style={{ width: '40px', height: '40px', fontSize: '1.2rem' }}>
                            <HiOutlineCalendar />
                        </div>
                        <div>
                            <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800 }}>Vencimientos</h1>
                            <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.85rem' }}>Control temporal de presentaciones</p>
                        </div>
                    </div>
                </div>
                <div className="dashboard-actions">
                    <button className="btn-gestion" onClick={exportarPDF} title="Exportar Vista Actual">
                        <HiOutlineDownload /> Exportar PDF
                    </button>
                    <button className="btn-nueva" onClick={onCerrar} style={{ background: 'rgba(255,255,255,0.05)', color: 'var(--text-primary)' }}>
                        <HiX /> Volver
                    </button>
                </div>
            </div>

            <div className="glass-panel" style={{ flex: 1, padding: '24px', borderRadius: 'var(--radius-lg)', minHeight: '600px', border: '1px solid var(--glass-border)' }}>
                <div ref={calendarioRef} style={{ height: '100%' }}>
                    <Calendar
                        localizer={localizer}
                        culture="es"
                        events={eventos}
                        startAccessor="start"
                        endAccessor="end"
                        views={['month', 'week', 'day', 'agenda']}
                        defaultView="month"
                        eventPropGetter={eventStyleGetter}
                        onSelectEvent={(e) => setEventoSeleccionado(e)}
                        onShowMore={(events, date) => setShowMoreState({ events, date })}
                        onNavigate={(d) => setFechaVisible(d)}
                        messages={{
                            month: "Mes",
                            week: "Semana",
                            day: "Día",
                            agenda: "Agenda",
                            today: "Hoy",
                            previous: "Anterior",
                            next: "Siguiente",
                            showMore: (total) => `+ ${total} más`,
                        }}
                    />
                </div>
            </div>

            <EventoModal
                evento={eventoSeleccionado}
                onClose={() => setEventoSeleccionado(null)}
                getColor={getColorByEstado}
            />

            <ShowMoreModal
                state={showMoreState}
                onClose={() => setShowMoreState(null)}
                onSelect={(e) => { setEventoSeleccionado(e); setShowMoreState(null); }}
                getColor={getColorByEstado}
            />
        </div>
    );
};

export default Calendario;